// extracted by mini-css-extract-plugin
export default {"containerText":"Articles_containerText__2kNCV","containerArticole":"Articles_containerArticole__gmQQv"};